import ModalBasicLayout from "../../../../components/Modal/ModalBasicLayout";
import { ADS_CAMPAIGNS_LOGS_TITLE } from "../../../../i18n/keysTranslations";
import { useTranslationApp } from "../../../../lib/i18next";
import CampaignLogs from "./CampaignLogs";

const ModalCampaingLogs = ({
  modalOpen,
  onCloseModal,
  enableReverse = false,
  getValues,
  setValue,
  onChangeSectionSelected,
}) => {
  const { t } = useTranslationApp();

  const reverseContext =
    enableReverse &&
    typeof getValues === "function" &&
    typeof setValue === "function"
      ? { getValues, setValue, onChangeSectionSelected }
      : null;

  return (
    <ModalBasicLayout
      modalOpen={modalOpen}
      onCloseModal={onCloseModal}
      title={t(ADS_CAMPAIGNS_LOGS_TITLE)}
      maxWidth="md"
      fullWidth
      scroll="paper"
    >
      <CampaignLogs
        sx={{
          px: 0,
        }}
        enableReverse={enableReverse}
        reverseContext={reverseContext}
      />
    </ModalBasicLayout>
  );
};

export default ModalCampaingLogs;
